import { render, staticRenderFns } from "./disputes.vue?vue&type=template&id=4607bfbd&"
import script from "./disputes.vue?vue&type=script&lang=js&"
export * from "./disputes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports